import PropTypes from 'prop-types'
import { Box, Checkbox, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { colors } from '../../../../utils/theme/styles'
import InfoLabel from '../../../EmployeeDetails/components/InfoLabel'
import { ItemWrapper } from './CompanyInfo'

export default function CardDelivery({ data }) {
  const { texts } = useLabels()
  return (
    <VStack spacing="20px" w="100%" alignItems="flex-start">
      <Box>
        <Heading color={colors.gray[800]} variant="h6">
          {texts.card_delivery}
        </Heading>
      </Box>
      <Text color={colors.gray[400]} variant="subtitle3">
        {texts.virtual_account}
      </Text>
      <HStack>
        <Checkbox isDisabled isChecked={data.bTarjetaVirtual}>
          Si
        </Checkbox>
        <Checkbox isDisabled isChecked={!data.bTarjetaVirtual}>
          No
        </Checkbox>
      </HStack>

      <HStack
        spacing={0}
        alignItems="flex-start"
        gap="16px"
        w="100%"
        wrap="wrap"
      >
        <ItemWrapper>
          <InfoLabel
            title={texts.replacement_delivery_frequency}
            value="Dato"
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={texts.contact_name}
            value={data.sInterlocutorOperativo}
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={texts.delivery_by_branch}
            value={data.bEntregaSucursal ? 'Si' : 'No'}
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={texts.email_contact}
            value={data.sEmailEntregaTarjeta}
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={texts.delivery_address}
            value={data.sDireccionEntregaTarjeta}
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel title={texts.phone} value={data.sTelefonoEntregaTarjeta} />
        </ItemWrapper>
      </HStack>
    </VStack>
  )
}

CardDelivery.propTypes = {
  data: PropTypes.shape({
    bEntregaSucursal: PropTypes.bool,
    bTarjetaVirtual: PropTypes.bool,
    sDireccionEntregaTarjeta: PropTypes.string,
    sEmailEntregaTarjeta: PropTypes.string,
    sInterlocutorOperativo: PropTypes.string,
    sTelefonoEntregaTarjeta: PropTypes.string,
  }),
}
